// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-select-options[data-v-0436699c] {\n  width: 100%;\n}\n.search-select-options .options-wrapper[data-v-0436699c] {\n    width: 100%;\n    display: flex;\n}\n.menu-item[data-v-0436699c] {\n  cursor: pointer;\n  position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
